import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Card3D — herbruikbare tegel-container met 3D-look.
 * Gebruikt door Orders Decoprof tabel-container; consistent met dashboard tegels.
 */
interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const Card3D = React.forwardRef<HTMLDivElement, Props>(
  ({ children, className, ...rest }, ref) => (
    <div
      ref={ref}
      className={cn(
        "relative rounded-xl border bg-card text-card-foreground",
        "shadow-[0_4px_12px_rgba(0,0,0,0.08),inset_0_1px_0_rgba(255,255,255,0.6)]",
        "transition-shadow hover:shadow-[0_6px_18px_rgba(0,0,0,0.10),inset_0_1px_0_rgba(255,255,255,0.7)]",
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  ),
);
Card3D.displayName = "Card3D";

export default Card3D;
